import Service from './common/services/Service';

let service = new Service();

let index = 0;

$(document).on('turbo:load turbo:render', () => {
    let i = $('.multi-search-select');
    index = $(".additional_entities_fields_for").length;


    i.each((index, element) => {
        let $el = $(element);
        //Remove previous select2 if using back button
        if ($el.next("span.select2-container").length) {
            $el.next("span.select2-container").remove();
        }

        let searchType = $el.data('search-type');
        let active = $el.data('search-active');
        let placeholder = $el.data('search-placeholder');
        let dropdown = $el.data('dropdown');
        let lobbyist_registration_id = $el.data('lobbyistRegistrationId');
        let user_id = $el.data('userId');

        //@ts-ignore
        $el.select2({
            placeholder: placeholder,
            theme: "bootstrap-5",
            // templateSelection: selectionFormat,
            ajax: {
                url: `/${searchType}/search`,
                dataType: 'json',
                data: (params) => {
                    let query = {
                        keyword: params.term,
                        type: searchType,
                        active: active,
                        authenticity_token: service.csrfToken()
                    };

                    // Query parameters will be ?search=[term]&type=public
                    return query;
                },
                processResults: (data) => {
                    //Removes entities that have already been chose from dropdown
                    //@ts-ignore
                    return {

                        results: data.message.map((i) => {
                            return {
                                "id": i._id,
                                "text": i.name,
                                "address": i.street,
                                "city": i.city,
                                "state": i.state,
                                "zip": i.zip,
                                "website": i.website,
                                "phone": i.phone,
                                "nature_of_business": i.nature_of_business,
                                "lobbyist_registration_id": lobbyist_registration_id,
                                "user_id": user_id
                            }
                        })
                    };
                },
                // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            },
            minimumInputLength: 2,
            dropdownParent: $(dropdown)
        });
    });


    i.on("select2:closing", (e) => {
        let $button = $("#additional-entity-search-dropdown ").find("#revealAddEntity");
        $button.remove();

    });

    i.on("select2:unselect", (e) => {
        //@ts-ignore
        let idToRemove = <any>e.params.data.id;
        let cardToRemove = $(`#${idToRemove}`).parent("fieldset");
        cardToRemove.remove();
        $(document).trigger("fieldChange")

    });

    i.on('select2:select', (e) => {
        let data = (<any>e).params.data;
        incrementCardNumbers();
        let selectedCard = $("#selected-entities-data");
        let $information = createResultsCard(data);
        selectedCard.prepend($information);
        appendChangeAddressButton(data);


        $(document).trigger("fieldChange")
    });

});

$(document).on("DOMNodeInserted DOMNodeRemoved ", () => {
    if ($("#additional-entity-search-dropdown").length) {
        let $container = $(document).find("#selectSearch");
        $container.find("input.select2-search__field").prop("placeholder", "Type to search for an Entity")

    }

});


function appendChangeAddressButton(data) {
    let $changeAddressButton = $(`<div class="col-md-12">
        <a class="change-address-button" data-remote="true" rel="nofollow" data-method="post" 
            href="/user/${data.user_id}/lobbyist_registrations/${data.lobbyist_registration_id}/add_entity_address?entity_id=${data.id}">
            Change address if different from above</a></div>`);

    $(`#addressFields${data.id}`).append($changeAddressButton);
}


function createResultsCard(data) {
    return $(`
           <fieldset class="card">
           <legend>Entity <span class="entity-card-number">1</span></legend>
            <br><br>
            <div class="selected-result-information" id = ${data.id}>
                <div class="">
                    <div class="row">
                        <div class="col-md-6">
                            <p>Name of Organization</p>
                            <p><strong>${data.text}</strong></p>
                        </div>
                         <div class="col-md-6">
                            <p>Website</p>
                            <p><strong>${data.website}</strong></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <p>Nature of Business</p>
                            <p><strong>${data.nature_of_business}</strong></p>
                        </div>
                    </div>
                    <div class = "row" id="addressFields${data.id}">
                        <div class="col-md-6">
                            <p>Address</p>
                            <p><strong>${data.address}, ${data.city} ${data.state} ${data.zip}</strong></p>
                        </div>
                         <div class="col-md-6">
                            <p>Phone</p>
                            <p><strong>${data.phone}</strong></p>
                        </div>
                    </div>
                </div>
            <br></div>
    </fieldset>
`);

}

function incrementCardNumbers() {
    $(".entity-card-number").each(function (i, el) {
        let $el = $(el);
        let number = parseInt($el.text());
        $el.text(number + 1);

    })
}
